import React, { FC, ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localizeObjectType, localizeType } from '../../commonType';
import { setPartnerCode, setPartnerId } from '../../features/offerConfirmation/offerConfirmationSlice';
import { RootState } from '../../redux/rootReducer';
import withLocalization from '../hoc/withLocalization';
import { DefaultPartners, getPartners, PartnerType } from './Memberships';

interface PartnersType {
  localize: localizeType;
  localizeObject: localizeObjectType;
}
const PARTNER_FIELD_VALIDATION = new RegExp('[aA-zZ0-9]{4,30}');

const Partners: FC<PartnersType> = (props: PartnersType): ReactElement => {
  const { localize, localizeObject } = props;
  const partnerNumverRef = useRef<HTMLInputElement>(null);
  const partnerIDFromStore = useSelector((state: RootState) => state.confirmation.PartnerId);
  const partnerCodeFromStore = useSelector((state: RootState) => state.confirmation.PartnerCode);

  const [partnerError, setpartnerError] = useState('');
  const [maxLength, setmaxLength] = useState(0);
  const [partnerId, setpartnerId] = useState(partnerIDFromStore ?? '');
  const [partnerCode, setpartnerCode] = useState(partnerCodeFromStore ?? '-1');
  const [partnersOption, setpartnersOption] = useState(<></>);
  const dispatch = useDispatch();

  useEffect(() => {
    const associatedPartners: PartnerType =
      localizeObject('preview-sales-engine.static-content.copy.partners.partner-info') ?? DefaultPartners;
    const partners = getPartners(associatedPartners);
    const options = partners.map((x, index) => (
      <option key={index} value={x.code}>
        {x.description}
      </option>
    ));
    setpartnersOption(options);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onPartnerDropdownChange = (e) => {
    const selectedValue = e.target.value;
    if (partnerNumverRef && partnerNumverRef.current) {
      partnerNumverRef.current.value = '';
    }
    setpartnerId('');
    setpartnerError('');
    if (selectedValue !== '-1') {
      setmaxLength(30);
      setpartnerCode(selectedValue);
    } else {
      setmaxLength(0);
      setpartnerCode('-1');
      dispatch(setPartnerCode(''));
      dispatch(setPartnerId(''));
    }
  };
  const onPartnerIDChange = (evt) => {
    const value = evt.target.value;
    if (PARTNER_FIELD_VALIDATION.test(value)) {
      setpartnerId(value);
      setpartnerError('');
    } else {
      setpartnerId('');
      setpartnerError('preview-sales-engine.static-content.copy.partners.valid-number-error');
    }
  };
  const onPartnerBlur = () => {
    if (partnerId && PARTNER_FIELD_VALIDATION.test(partnerId)) {
      dispatch(setPartnerCode(partnerCode));
      dispatch(setPartnerId(partnerId));
    } else {
      dispatch(setPartnerCode(''));
      dispatch(setPartnerId(''));
    }
  };
  return (
    <div className="row membershipWrapper">
      <div className="col-md-6">
        <label htmlFor="partners">
          {localize('preview-sales-engine.static-content.copy.partners.select-partner-label')}
          {/*eslint-disable-next-line jsx-a11y/no-onchange*/}
          <select id="partners" onChange={onPartnerDropdownChange} value={partnerCode}>
            <option value="-1">
              {localize('preview-sales-engine.static-content.copy.partners.please-select-label')}
            </option>
            {partnersOption}
          </select>
        </label>
      </div>
      <div className="col-md-6">
        <label htmlFor="partnetNumber">
          {localize('preview-sales-engine.static-content.copy.partners.number-label')}

          <input
            type="text"
            id="partnetNumber"
            ref={partnerNumverRef}
            maxLength={maxLength}
            defaultValue={partnerId}
            onChange={onPartnerIDChange}
            onBlur={onPartnerBlur}
          ></input>
          <span className="invalid-feedback-onchange">{localize(partnerError)}</span>
        </label>
      </div>
    </div>
  );
};
export default React.memo(withLocalization(Partners));
